import type { ButtonProps } from "antd";
import type { MouseEventHandler } from "react";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useMarkAllNotificationsDatabaseAsRead } from "@/entities/notifications-database";

export const NotificationsMarkAllButton = ({
  onClick,
  loading,
  ...props
}: ButtonProps) => {
  const { t } = useTranslation();
  const { markAllAsRead, isPending } = useMarkAllNotificationsDatabaseAsRead();

  const onButtonClick: MouseEventHandler<HTMLElement> = (e) => {
    markAllAsRead();
    onClick?.(e);
  };

  return (
    <Button loading={isPending || loading} onClick={onButtonClick} {...props}>
      {t("notification:markAllButton")}
    </Button>
  );
};
